export class SearchRoutePaths {
  public static readonly Category = 'category/:category'
  public static readonly CategoryFull = '/equipment/category/:category'
  public static readonly Subcategory = 'category/:category/subcategory/:subcategory'
  public static readonly SubcategoryFull = '/equipment/category/:category/subcategory/:subcategory'
  public static readonly Make = 'make/:make'
  public static readonly MakeFull = '/equipment/make/:make'
  public static readonly Model = 'make/:make/model/:model'
  public static readonly Country = 'country/:country'
  public static readonly State = 'country/:country/state/:state'
  public static readonly City = 'country/:country/state/:state/city/:city'
}
